import { Draft, PayloadAction } from '@reduxjs/toolkit';
import formatters from 'formatters';

import IUpdateNoteInterventionResponse from 'services/httpClient/responses/intervention/IUpdateNoteInterventionResponse';

import { IInterventionData } from '../../initialState';

interface IUpdateNoteInterventionSuccessAction {
  note: IUpdateNoteInterventionResponse;
  isArchive: boolean;
}

function updateNoteSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IUpdateNoteInterventionSuccessAction>,
) {
  draft.updateNote.config.isLoading = false;

  if (draft.getDetails.values) {
    if (action.payload.isArchive) {
      draft.getDetails.values.notes = draft.getDetails.values.notes.filter(
        note => note.id !== action.payload.note.id,
      );
    } else {
      draft.getDetails.values.notes = draft.getDetails.values.notes.map(
        note => {
          if (note.id === action.payload.note.id) {
            return {
              id: note.id,
              createdAt: formatters.date(action.payload.note.created_at, {
                formatType: 'DD/MM/YYYY',
              }),
              text: action.payload.note.text,
              wroteBy: action.payload.note.wrote_by,
            };
          }
          return note;
        },
      );
    }
  }
}

export default updateNoteSuccess;
